module.exports = __webpack_public_path__ + "img/site2.ff7c83eb.jpg";